/**
 * useScript composable for adding scripts with OneTrust autoblock support
 *
 * This composable uses useHead to add scripts with proper OneTrust attributes
 * for consent management and autoblock functionality.
 *
 * @param {Object} attributes - Script URL or inline content
 * @param {string} category - OneTrust category ID (e.g., 'C0004')
 *
 * @example
 * // Add external script with consent category
 * useScript({ src: 'https://analytics.example.com/script.js' }, 'C0004');
 *
 * // Add inline script with consent category
 * useScript({ innerHTML: 'console.log("Analytics ready");' }, 'C0004', { id: 'analytics-init' });
 *
 * // Add script without consent requirement
 * useScript({ src: 'https://example.com/script.js' });
 */

export const consentCategories = {
  C0001: 'Strictly Necessary Cookies',
  C0002: 'Performance Cookies',
  C0003: 'Functional Cookies',
  C0004: 'Targeting Cookies',
  C0005: 'Social Media Cookies',
};

export const useScript = (attributes = {}, category) => {
  const scriptConfig = {
    ...attributes,
  };

  // check if category is in consentCategories
  if (category && !Object.keys(consentCategories).includes(category)) {
    console.warn(
      `Invalid OneTrust category: ${category}. Available categories: ${Object.keys(consentCategories).join(', ')}`
    );
    return;
  }

  // Add OneTrust autoblock attributes if category is provided
  if (category) {
    scriptConfig.type = 'text/plain';
    scriptConfig.class = `optanon-category-${category}`;
  } else {
    // Default script type if no category
    scriptConfig.type = scriptConfig.type || 'text/javascript';
  }

  // Use useHead to add the script
  useHead({
    script: [scriptConfig],
  });
};
